import { render } from "./PictureViewer.vue?vue&type=template&id=60eb1238&scoped=true"
import script from "./PictureViewer.vue?vue&type=script&lang=js"
export * from "./PictureViewer.vue?vue&type=script&lang=js"

import "./PictureViewer.vue?vue&type=style&index=0&id=60eb1238&scoped=true&lang=css"

import exportComponent from "/home/www/.jenkins/workspace/131-front-vue-8081/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60eb1238"]])

export default __exports__